// React
import { useEffect, useState } from "react"

// Third-Party Libraries
import axios from "axios"
import toast from "react-hot-toast"

// Types
import type { SelectOptionType, SuccessFetch } from "types"
import type { FieldType, MasterType, ReturnMasterType } from "../../types"

// Utils
import { useApi } from "utils"
import { defaultMasterData } from "../vars"

export function useMasterData(): ReturnMasterType {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<MasterType>(defaultMasterData)
  const [isError, setError] = useState<boolean>(false)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    axios.all([
      api.get("/customer/")
    ]).then(axios.spread((
      customer
    ) => {
      // Vars
      const customer_value: SuccessFetch<{
        payload: {
          customer_id: number
          customer_code: string
        }[]
      }> = customer

      const result: MasterType = {
        customer: customer_value.data.payload.map(item => ({
          label: item.customer_code,
          value: item.customer_id.toString()
        }))
      }

      setData(result)
    })).catch(() => {
      toast.error("Fetching Data Master Error")
      setError(true)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData(defaultMasterData)
      setError(false)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  // Functions
  const appendData = (
    field: FieldType,
    value: SelectOptionType
  ) => {
    setData(prev => {
      // Vars
      const newValue = [...prev[field]]
      newValue.push(value)

      return {
        ...prev,
        [field]: newValue
      }
    })
  }

  return { data, isError, isLoading, appendData }
}